import React from 'react';
import PropTypes from 'prop-types';

import { getAppProps } from '@pages/_app';
import { buildDataUrl } from '@helper/api';
import Archive from '@components/organisms/archive/archive';
import TemplateDefault from '../../templates/default/default';

const ArchivePage = ({ data }) => {
  // console.log(data);
  return (
    <TemplateDefault isArchivePage>
      <Archive data={data} />
    </TemplateDefault>
  );
};

ArchivePage.propTypes = {
  data: PropTypes.shape()
};

const getArchiveProps = async ({ locale, uri }) => {
  const getPageProps = fetch(buildDataUrl(`${locale || 'de'}/${process.env.NEXT_PUBLIC_JSON_API_PATH}/${uri}`))
    .then(res => res.json())
    .catch(err => console.error(err));

  const [appProps, data] = await Promise.allSettled([getAppProps({ locale }), getPageProps]).then(
    results => results.map(result => result.value)
  );

  return {
    PAGE_TYPE: 'ARCHIVE',
    ...appProps,
    ...data
  };
};

export default ArchivePage;
export { getArchiveProps };
